const { ACTION, APP_REBOOT, APP_INIT_COMPLETE, SOUND_CHANGE } = require("./actions");

// ============================

const initialState = {
    dbg_pressedIndex: 0,
    isInitialize: false,
    soundEnable: true
};

export function appState(state = initialState, action) {
    // console.log(`# appState: ${JSON.stringify(state)} -> ${JSON.stringify(action)}`);
    switch (action.type) {
        case ACTION:
            return {
                ...state,
                dbg_pressedIndex: action.index
            }
        case APP_REBOOT:
            return initialState;
        case APP_INIT_COMPLETE:
            return {
                ...state,
                isInitialize: true
            }
        case SOUND_CHANGE:
            return {
                ...state,
                soundEnable: !state.soundEnable
            };
        default:
            return state;
    }
}


